import { Language, Messages } from "./Language";
import { Constants } from "../Utils/Constants";

export class DemoMode extends Phaser.GameObjects.Container {
	constructor(scene: Phaser.Scene) {
		super(scene)

		this.textF = new Phaser.GameObjects.Text(this.scene, 0, 0, "", (Constants.DEMO_MODE.FONT as Phaser.GameObjects.TextStyle));
		this.textF.autoRound = true;
		this.textF.setOrigin(0.5);
		this.textF.setAngle(-45);
		this.textF.alpha = 0.08;
		this.add(this.textF);
		this.setDepth(-10);

		this.initializeWithDOM();
	}

	OnResize(width: number, height: number, portraitMode?: boolean) {

		this.textF.setSize(width, height);
		this.textF.setPosition(width / 2, height / 2);
	}

	private initializeTextField(): void {
		this.textF.setSize(this.startScreenW, this.startScreenH);
		this.textF.setPosition(this.startScreenW / 2, this.startScreenH / 2);
		let lineLock: boolean = false;
		let lineCounter: number = 0;
		for (let index = 0; index < 1000; index++) {
			this.textF.setText(this.textF.text + " " + Language.Get(Messages.DEMO));
			if ((this.textF.displayWidth >= this.startScreenW) && !lineLock) {
				this.textF.setText(this.textF.text + "\n");
				lineCounter = index;
				lineLock = true;
				continue;
			}

			if (index % lineCounter == 0 && lineLock)
				this.textF.setText(this.textF.text + "\n");

			if (this.textF.displayHeight >= this.startScreenH)
				return;
		}
	}

	private initializeWithDOM(): void {
		let textElement = document.createElement('span');
		document.body.appendChild(textElement);

		let fontsize = parseInt(Constants.DEMO_MODE.FONT.fontSize) * this.upscaleFactor;
		textElement.style.fontSize = fontsize + "px";

		textElement.innerText = "DEMO ";
		let textDimensi = textElement.getClientRects();
		let textWidth = textDimensi[0].width
		let textHeight = textDimensi[0].height

		textElement.remove()

		this.startScreenW = window.innerWidth // 1920
		this.startScreenH = window.innerHeight // 1080

		let totalXRepeats = (window.devicePixelRatio * 2 * this.startScreenW) / textWidth
		let totalYRepeats = (window.devicePixelRatio * 3 * this.startScreenH) / textHeight

		let text = ""
		for (let i = 0; i < Math.round(totalXRepeats); i++) {
			text += "DEMO "
			if (i == Math.round(totalXRepeats) - 1) text += "DEMO\n"
		}
		let t = ""
		for (let i = 0; i < Math.round(totalYRepeats); i++) {
			t += text
		}

		this.textF.setSize(this.startScreenW, this.startScreenH);
		this.textF.setPosition(this.startScreenW / 2, this.startScreenH / 2);
		this.textF.setFontFamily(Constants.DEMO_MODE.FONT.fontFamily)
		this.textF.setFontSize(fontsize)
		this.textF.setText(t)
	}

	private textF: Phaser.GameObjects.Text;
	private startScreenW: number = 800;
	private startScreenH: number = 600;
	private upscaleFactor = 4.5;
}
